import { AppState } from '../reducers';
import { Action } from 'redux';
import {
  PublishErrors,
  publishErrors,
  publishStoryLoad,
} from './story-publish.actions';
import { ImmutableObject } from 'seamless-immutable';
import * as Immutable from 'seamless-immutable';
import { isType } from 'typescript-fsa/lib';

export type StoryPublishState = PublishErrors & ImmutableObject<PublishErrors>;

const initialState = Immutable.from<PublishErrors>({
  errors: [],
  warnings: [],
});

export default function reduce(
  state: StoryPublishState = initialState,
  action: Action
) {
  if (isType(action, publishStoryLoad)) {
    return state.merge({ errors: [], warnings: [] });
  }

  if (isType(action, publishErrors)) {
    return state.merge(action.payload);
  }

  return state;
}

export function getPublishErrors(state: AppState) {
  const { storyPublish } = state;

  return storyPublish;
}



// WEBPACK FOOTER //
// ./src/store/StoryPublish/story-publish.reducer.ts